import React from "react";
import "./color.css";
import Input from "../../components/Input";

export default function Colors({ handleChange }) {
  return (
    <div>
      <h3 className="sidebar-title">Colors</h3>
      <div>
        <Input
          handleChange={handleChange}
          value="all"
          title="All"
          name="coloring"
          color="all"
        />
        <Input
          handleChange={handleChange}
          value="black"
          title="Black"
          name="coloring"
          color="black"
        />
        <Input
          handleChange={handleChange}
          value="blue"
          title="Blue"
          name="coloring"
          color="blue"
        />
        <Input
          handleChange={handleChange}
          value="green"
          title="Green"
          name="coloring"
          color="green"
        />
        <Input
          handleChange={handleChange}
          value="red"
          title="Red"
          name="coloring"
          color="red"
        />
        <Input
          handleChange={handleChange}
          value="white"
          title="White"
          name="coloring"
          color="white"
          border="2px solid black"
        />
      </div>
    </div>
  );
}
